// Covers headers AND the response body, including a bounded scope-repair pass.
export const QUOTE_ANALYSIS_TIMEOUT_MS = 10 * 60 * 1000;

export async function withQuoteAnalysisDeadline<T>(
  operation: (signal: AbortSignal) => Promise<T>,
): Promise<T> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), QUOTE_ANALYSIS_TIMEOUT_MS);
  try {
    return await operation(controller.signal);
  } finally {
    clearTimeout(timer);
  }
}
